export enum EmployeeDocumentType {
    NID = 'NID',
    CV = 'CV',
    LAST_ACADEMIC_CERTIFICATE = 'LAST_ACADEMIC_CERTIFICATE',
    JOINING_LETTER = 'JOINING_LETTER',
    APPOINTMENT_LETTER = 'APPOINTMENT_LETTER',
    PASSPORT_SIZE_PICTURE = 'PASSPORT_SIZE_PICTURE',
    RESIGNATION_LETTER = 'RESIGNATION_LETTER',
}

export const EMPLOYEE_DOCUMENT_TYPE_LABELS: Record<EmployeeDocumentType, string> = {
    [EmployeeDocumentType.NID]: 'NID',
    [EmployeeDocumentType.CV]: 'CV',
    [EmployeeDocumentType.LAST_ACADEMIC_CERTIFICATE]: 'Last Academic Certificate',
    [EmployeeDocumentType.JOINING_LETTER]: 'Joining Letter',
    [EmployeeDocumentType.APPOINTMENT_LETTER]: 'Appointment Letter',
    [EmployeeDocumentType.PASSPORT_SIZE_PICTURE]: 'Passport Size Picture',
    [EmployeeDocumentType.RESIGNATION_LETTER]: 'Resignation Letter',
};

export const ALL_DOCUMENT_TYPES = Object.values(EmployeeDocumentType);

export interface IEmployeeDocument {
    id: string;
    userId: string;
    documentType: EmployeeDocumentType;
    originalFileName: string;
    contentType: string;
    fileSize: number;
}
